import { DotData } from '@/compositions/Dots/Dots'

export const getDots = (amount: number, filledAmount: number): DotData[] => Array.from({ length: amount }, (_, index) => ({
    id: index.toString(),
    isFilled: index < filledAmount,
}))
